import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CountDown from '../Countdown/Countdown';

import { TXTWCL_Total_spinsX_N0 } from './AdditionalDetails.messages.json';
import styles from './AdditionalDetails.scss';

interface Props {
  totalSpins: number;
  expiryTime: number;
}

const AdditionalDetails: React.FC<Props> = ({ totalSpins, expiryTime }) => (
  <div className={styles.container}>
    <div>
      <Translation
        {...TXTWCL_Total_spinsX_N0}
        values={{
          0: totalSpins
        }}
      />
    </div>
    <CountDown endTime={expiryTime} />
  </div>
);

export default AdditionalDetails;
